// import { useEffect, useState } from 'react'
import { ApplicationRoutes, useCurrentRootPath } from '~/hooks/useRouting'
import { useSharedVariable } from '~/hooks/useSharedVariable'
import { isElectron } from '~/utils/common'
// import {
//   getSnapshotAlwaysOnTop,
//   subscribeAlwaysOnTop,
// } from '~/utils/electronUtils'
import {
  addMessageToQueue,
  addPhoneCallToQueue,
  removeItemFromQueueByType,
} from '~/utils/popupQueueUtils'

import {
  CallQueueItem,
  MessageQueueItem,
  MessageThread,
  PhoneCall,
  PopupQueueItemTypes,
} from '@mangovoice/types'

const usePopupWindow = () => {
  const currentRoot = useCurrentRootPath()

  const { isMainWindowFocused } = useMainWindow()
  const [messageQueue, setMessageQueue] =
    useSharedVariable<MessageQueueItem[]>('MessageQueue')
  const [callQueue, setCallQueue] =
    useSharedVariable<CallQueueItem[]>('CallQueue')

  const showPopupWindow = () => {
    window.electron?.send('show-popup-window')
  }

  const hidePopupWindow = () => {
    window.electron?.send('hide-popup-window')
  }

  const addCallToPopupQueue = (call: PhoneCall) => {
    if (call) {
      setCallQueue(addPhoneCallToQueue(callQueue || [], call))
    }
  }

  const addTextToPopupQueue = (message: MessageThread[]) => {
    const isMessagingRoute = currentRoot === ApplicationRoutes.MESSAGING

    const doAction = () => {
      setMessageQueue(addMessageToQueue(messageQueue || [], message))
      showPopupWindow()
    }

    if (message) {
      if (message?.length) {
        isMainWindowFocused()?.then((isFocused: boolean) => {
          if (isMessagingRoute) {
            if (!isFocused) {
              doAction()
            }
          } else {
            doAction()
          }
        })
      }
    }
  }

  const clearCallsFromPopup = () => {
    setCallQueue(
      removeItemFromQueueByType(callQueue || [], PopupQueueItemTypes.CALL),
    )
  }

  return {
    hidePopupWindow,
    showPopupWindow,
    clearCallsFromPopup,
    addCallToPopupQueue,
    addTextToPopupQueue,
  }
}

const useMainWindow = () => {
  const focusMainWindow = (postFocusEvent?: string) => {
    if (isElectron) {
      window.electron?.send('focus-main-window', postFocusEvent)
    }
  }

  const isMainWindowFocused = (): Promise<any> | undefined => {
    if (isElectron) {
      return window.electron
        ?.invoke('get-main-is-focused')
        .then((isFocused) => isFocused)
    } else {
      return new Promise((resolve) => resolve(true))
    }
  }

  const answerPhoneCall = () => {
    if (isElectron) {
      window.electron?.send('popup-answer-call')
    }
  }

  const answerCallWithEnd = () => {
    if (isElectron) {
      window.electron?.send('popup-answer-call-with-end')
    }
  }

  const answerCallWithHold = () => {
    if (isElectron) {
      window.electron?.send('popup-answer-call-with-hold')
    }
  }

  const rejectPhoneCall = () => {
    if (isElectron) {
      window.electron?.send('popup-reject-call')
    }
  }

  const parkCall = () => {
    if (isElectron) {
      window.electron?.send('popup-park-call')
    }
  }

  return {
    focusMainWindow,
    isMainWindowFocused,
    answerPhoneCall,
    rejectPhoneCall,
    answerCallWithEnd,
    answerCallWithHold,
    parkCall,
  }
}

// export const useIsAlwaysOnTop = () => {
//   const [alwaysOnTop, setAlwaysOnTop] = useState(false)
//
//   useEffect(() => {
//     getSnapshotAlwaysOnTop().then((value) => {
//       setAlwaysOnTop(value)
//     })
//   }, [])
//
//   useEffect(() => {
//     const handleAlwaysOnTopChanged = (
//       newAlwaysOnTop: boolean | ((prevState: boolean) => boolean),
//     ) => {
//       setAlwaysOnTop(newAlwaysOnTop)
//     }
//     const unsub = subscribeAlwaysOnTop(handleAlwaysOnTopChanged)
//
//     return () => {
//       unsub()
//     }
//   }, [])
//
//   return alwaysOnTop
// }

export { usePopupWindow, useMainWindow }
